import { makeApiaUrl } from '../../../../api/apiaApi/apiaApi';
import store from '../../../../store';
import { updateActionEvent } from '../../../../store/appStateSlice';
import getAction from '../../../common/actions/getAction';
import { hideAppletModal } from './AppletModal';

declare global {
  interface Window {
    appletCloser: (result: boolean, tkn: string) => void;
    appletNextStepConfirmer: (result: boolean, tkn: string) => void;
    appletConfirmer: (result: boolean, tkn: string) => void;
    forceAppletConfirmer: () => void;
    appletToken?: string;
    forceConfirm: boolean;
    signedOK: boolean;
    TIT_SING_DOCS_MODAL_LBL: string;
    TIT_SING_MODAL_LBL: string;
    TIT_SING_MODAL_PREV_LBL: string;
  }
}

export const canNotExportDefault = true;

export async function initializeDigitalSignature() {
  window.appletToken = '';
  window.forceConfirm = false;

  const confirm = await getAction('execution/task/confirm');
  const next = await getAction('execution/task/next');

  if (!confirm || !next)
    throw new Error(
      'There is no confirm or next action. Digital sign cannot be initialized.',
    );

  window.appletConfirmer = (result: boolean, tkn: string) => {
    window.signedOK = result;
    window.appletToken = tkn;

    if (store.getState().appStateSlice.prevActionState === 'btnNext') next();
    else confirm();

    hideAppletModal();
  };

  window.forceAppletConfirmer = () => {
    window.forceConfirm = true;

    updateActionEvent('form-on-force-confirm');

    window.forceConfirm = false;
    hideAppletModal();
  };

  window.appletCloser = (result: boolean, tkn: string) => {
    window.signedOK = result;

    if (tkn) {
      confirm();
    }

    hideAppletModal();
  };

  window.appletNextStepConfirmer = (result: boolean, tkn: string) => {
    window.signedOK = result;
    window.appletToken = tkn;

    next();
    hideAppletModal();
  };
}

export function markFormToSignURL({
  frmId,
  frmParent,
  sign,
}: {
  frmId: string;
  frmParent: string;
  sign: boolean;
}) {
  return makeApiaUrl({
    ajaxUrl: '/apia.execution.FormAction.run',
    action: 'markFormToSign',
    frmId,
    frmParent,
    sign,
  });
}
